import { lazy } from "react";
import { Navigate } from "react-router-dom";

import AuthGuard from "./auth/AuthGuard";
import { authRoles } from "./auth/authRoles";

import Loadable from "./components/Loadable";
import MatxLayout from "./components/MatxLayout/MatxLayout";

import materialRoutes from "app/views/material-kit/MaterialRoutes";
import authRoutes from "./views/auth/auth-routes";
import sessionRoutes from "./views/sessions/session-routes";
import OnBoardingScreen from "./views/app-resources/OnBoardingScreen";
import ContentCreationStepper from "./views/content/ContentCreationStepper";
import AuthorList from "./views/authors/AuthorList";
import LoadingMessages from "./views/app-resources/LoadingMessages";
import AuditLogs from "./views/systems/AuditLogs";
import ActivityLogs from "./views/systems/ActivityLogs";

// E-CHART PAGE
const AppEchart = Loadable(lazy(() => import("app/views/charts/echarts/AppEchart")));
// DASHBOARD PAGE
const Analytics = Loadable(lazy(() => import("app/views/dashboard/Analytics")));
// CATEGORY PAGE
const Category = Loadable(lazy(() => import("app/views/category/Category")));
// CONTENT PAGE
const Content = Loadable(lazy(() => import("app/views/content/Content")));

const routes = [
  {
    path: "/",
    element: <Navigate to="dashboard/default" />
  },
  {
    element: (
      <AuthGuard>
        <MatxLayout />
      </AuthGuard>
    ),
    children: [
      ...materialRoutes,
      // dashboard route
      {
        path: "/dashboard/default",
        element: <Analytics />,
        auth: authRoles.admin
      },
      {
        path: "/category",
        element: <Category />,
        auth: authRoles.admin
      },
      {
        path: "/content",
        element: <Content />,
        auth: authRoles.admin
      },
      {
        path: "/content/create",
        element: <ContentCreationStepper />,
        auth: authRoles.admin
      },
      {
        path: "/content/edit/:contentId",
        element: <ContentCreationStepper />,
        auth: authRoles.admin
      },
      {
        path: "/resources/onboarding",
        element: <OnBoardingScreen />,
        auth: authRoles.admin
      },
      {
        path: "/resources/loadingmessages",
        element: <LoadingMessages />,
        auth: authRoles.admin
      },
      // {
      //   path: "/resources/relationship",
      //   element: <RelationshipLevelsScreen />,
      //   auth: authRoles.admin
      // },
      {
        path: "/authors",
        element: <AuthorList />,
        auth: authRoles.admin
      },
      {
        path: "/system/audit-logs",
        element: <AuditLogs />,
        auth: authRoles.admin,
      },
      {
        path: "/system/activity-logs",
        element: <ActivityLogs />,
        auth: authRoles.admin,
      },
      // auth pages route
      ...authRoutes,
    ]
  },
  // session pages route
  ...sessionRoutes
];

export default routes;
